<template>
    <div class="action-wrapper">
        <slot name="prepend" />

        <slot>
            <div class="searchbar mb-2">
                <v-text-field
                    class="v-input-field--search"
                    outlined
                    clearable
                    dense
                    :placeholder="placeholder"
                    v-model="search"
                    @keyup.enter="sendFilters"
                    @click:clear="clearText"
                />
                <v-btn dense class="button" @click="sendFilters">
                    <v-icon small>mdi-magnify</v-icon>
                </v-btn>
            </div>
            <div class="mx-md-5 mx-lg-5 mx-sm-2 mx-0 mb-2 control-panel-actions">
                <v-menu :close-on-content-click="false" :offset-y="true" :attach="true">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="v-btn--filter" v-bind="attrs" v-on="on">
                            <div>
                                {{ $t('app.filter') }}
                                <v-avatar size="18" class="filter-num">{{ selectedFilters.length }}</v-avatar>
                            </div>
                            <v-icon>mdi-filter</v-icon>
                        </v-btn>
                    </template>

                    <v-list class="filter-list" dense elevation="0" expand>
                        <v-subheader><b>{{ $t('app.filters') }}</b></v-subheader>
                        <v-list-group v-for="(filter, i) in availableFilters" :key="i">
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title dense>{{ filter.title }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <v-list-item
                                class="filter"
                                dense
                                v-for="(item, i) in filter.items"
                                :key="i"
                            >
                                <v-list-item-content>
                                    <v-checkbox
                                        class="input-checkbox"
                                        multiple
                                        hide-details
                                        dense
                                        :label="item.title"
                                        v-model="filters[filter.key]"
                                        :value="item.id"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider />
                        </v-list-group>
                        <div class="btn-container" style="margin-bottom: 18px;">
                            <v-btn
                                class="v-btn--primary v-btn--filter-actions small-body"
                                @click="sendFilters"
                            >
                                {{ $t('app.apply') }}
                            </v-btn>
                            <v-btn
                                class="v-btn--secondary v-btn--filter-actions small-body"
                                @click="clearFilters"
                            >
                                {{ $t('app.clear') }}
                            </v-btn>
                        </div>
                    </v-list>
                </v-menu>
            </div>
        </slot>

        <slot name="append" />
    </div>
</template>

<script>
import {mapState} from 'pinia';
import _ from "lodash";
import {EventBus} from "@/event-bus";
import {DataGatheringsStore} from "@/Store/DataGatherings/DataGatheringsStore";
import DataGatheringRepository from "@/Repositories/DataGathering/DataGatheringRepository";

export default {
    name: "DataGatheringFilters",

    data() {
        return {
            search: "",
            placeholder: "",
            filters: {
                academic_periods: [],
                types: [],
                statuses: [],
            },
        }
    },

    methods: {
        sendFilters() {
            let filters = Object.assign({}, this.filters, {
                text: this.search
            });

            this.$emit('filter', filters);

            EventBus.$emit('gicu-app.data-gatherings.filter', filters);
        },

        clearFilters() {
            this.filters = {
                academic_periods: [],
                types: [],
                statuses: [],
            };

            this.sendFilters();
        },

        clearText() {
            this.search = '';
            this.sendFilters();
        }
    },

    computed: {
        availableFilters() {
            const academicPeriodFilters = {
                title: this.$t('data_gatherings.academic_period'),
                key: 'academic_periods',
                items: this.academicPeriods,
            };

            const types = {
                title: this.$t('data_gatherings.type'),
                key: 'types',
                items: this.types,
            };

            const statuses = {
                title: this.$t('data_gatherings.status'),
                key: 'statuses',
                items: DataGatheringRepository.getStatuses(),
            };

            return [academicPeriodFilters, types, statuses];
        },

        selectedFilters() {
            let filters = [];

            filters.push(...(this.filters.academic_periods || []));
            filters.push(...(this.filters.types || []));
            filters.push(...(this.filters.statuses || []));

            return filters;
        },

        ...mapState(DataGatheringsStore, [
            'types',
            'academicPeriods',
        ]),
    },

    mounted() {
        this.placeholder = [
            this.$t('data_gatherings.filters.name'),
            this.$t('data_gatherings.filters.notes'),
        ].join(', ').toLowerCase();
    },
}
</script>

<style scoped lang="scss">
    .v-menu__content {
        z-index: 4 !important;
    }
</style>
